var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceBlack = function SvgFaceBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24,
    r: 24,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.845 25.107.518-3.413h-3.242v-2.213c0-.934.452-1.845 1.904-1.845H29.5V14.73s-1.338-.231-2.616-.231c-2.672 0-4.416 1.635-4.416 4.593v2.601H19.5v3.413h2.968v8.25a11.64 11.64 0 0 0 3.653 0v-8.25h2.724Z",
    fill: "#363940"
  })));
};
export default SvgFaceBlack;